module.exports = __webpack_public_path__ + "static/media/fees.9f8a5382.svg";